'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { GA_EVENT_NAME, PAGE_URL } from '@/app/constants/tailwind';
import { isServer } from '@/app/utils/browser';
import { isDataLayerAvailable } from '@/tag-manager';
import { CUSTOM_EVENT_DYNAMIC_EVENT } from '@/tag-manager/constants';
export const useSupportTailwindV4 = () => {
  const router = useRouter();
  // Check Tailwind V4 compatibility
  useEffect(() => {
    if (isServer) return;
    const isTailwindV4Support = getComputedStyle(document.documentElement).getPropertyValue('--spacing' // Tailwind V4 core variable
    ) !== '';
    if (window.location.pathname === PAGE_URL || isTailwindV4Support) return;
    if (isDataLayerAvailable()) {
      window.dataLayer.push({
        event: CUSTOM_EVENT_DYNAMIC_EVENT,
        event_name: GA_EVENT_NAME,
        url: window.location.toString()
      });
    }
    router.replace(PAGE_URL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};